// src/utils/formUtils.js

// Extracts valid filters from answers and selected options
export const extractFilters = (answers, questions, selectedOptions) => {
  const filters = [];

  Object.keys(answers).forEach((questionId) => {
    const question = questions.find((q) => q.id === parseInt(questionId));
    const answer = answers[questionId];

    if (answer === "Yes") {
      if (question.requiresDropdown) {
        const selectedValue = selectedOptions[questionId];

        if (selectedValue) {
          filters.push({
            field: question.field,
            value: selectedValue,
          });
        } else {
          throw new Error(`Please select an option for Question ${questionId}`);
        }
      } else {
        filters.push({
          field: question.field,
          value: true,
        });
      }
    }
  });

  return filters;
};

// Displays an alert for missing selections
export const validateFilters = (filters) => {
  if (filters.length === 0) {
    throw new Error(
      "No filters selected. Please answer at least one question with 'Yes' and make a selection"
    );
  }
};

export const getLastKey = (obj) => {
  const keys = Object.keys(obj);
  return keys.length > 0 ? keys[keys.length - 1] : null;
};
